import * as React from 'react';
import { BREAK_POINTS } from '../../consts/style';
import { IMAGE_DEFAULTS, Sizes } from '../../consts/image';
import { getCloudinaryUrl } from '../../services/cloudinary';
import { IDamImage } from '../../models/content.interfaces';

interface Props {
  image: IDamImage;
  alt: string;
  imageWidths?: number[];
  sizes?: Sizes;
  maxWidth?: string;
  quality?: number;
  width?: string;
  title?: string;
  style?: any;
}

export const ResponsiveImage = ({
  image,
  alt,
  maxWidth = IMAGE_DEFAULTS.MAX_WIDTH,
  imageWidths = IMAGE_DEFAULTS.WIDTHS,
  sizes = IMAGE_DEFAULTS.SIZES,
  quality = IMAGE_DEFAULTS.QUALITY,
  width,
  title,
  style,
}: Props) => {
  const srcSet = imageWidths.reduce((srcSetAcc, imageWidth) => {
    return srcSetAcc + `${getCloudinaryUrl(image, imageWidth, true, quality)} ${imageWidth}w, `;
  }, '');

  const sizeSet =
    Object.keys(sizes).reduce((sizeSetAcc, key) => {
      const breakpoint = key;
      const viewportSize = sizes[key];
      return sizeSetAcc + `(max-width: ${BREAK_POINTS.MAX[breakpoint]}) ${viewportSize}, `;
    }, '') + ` ${maxWidth}`;

  return (
    <img
      style={style}
      sizes={sizeSet}
      srcSet={srcSet}
      src={getCloudinaryUrl(image)}
      alt={alt}
      width={width}
      title={title}
    />
  );
};
